import { useTokenSupply } from ".";
import { DEFAULT_CHAIN_ID, URUS_LP_TOKEN } from "../constants";
import { useEthers } from "./useEthers";

export function useLPTokenSupply() {
  const { chainId = DEFAULT_CHAIN_ID } = useEthers();
  return useTokenSupply(URUS_LP_TOKEN[chainId]);
}
